import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChartComponent = () => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
    datasets: [
      {
        // label: 'Sales', // تم إزالة الليبل
        data: [1800, 2200, 1500, 1900, 200, 2000, 2300],
        backgroundColor: '#a6d7f9', // لون أعمدة المبيعات
      },
      {
        // label: 'Orders', // تم إزالة الليبل
        data: [240, 280, 2000, 260, 1500, 250, 1000],
        backgroundColor: '#006db8',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // إخفاء وسيلة الإيضاح
      },
      title: {
        display: false, // إخفاء العنوان
      },
    },
    scales: {
      y: {},
    },
  };

  return <Bar data={data} options={options} />;
};

export default BarChartComponent;